import { gql } from '@apollo/client';

export const GET_RENT_CHARGES_REPORT = gql`
  query GetRentChargesReport($filterInput: RentChargesReportFilterInput) {
    rentChargesReport(filterInput: $filterInput) {
      items {
        id
        rentChargeTypeOption
        description
        executionDate
        dueDate
        amountValue
        rentChargeStatusOption
        currencyOption
        tenant {
          firstName
          lastName
        }
        payments {
          id
          createdAt
          paymentStatusOption
          amountValue
          providerData {
            __typename
            ... on StripePaymentReportOutput {
              operationId
            }
            ... on RedsysPaymentReportOutput {
              order
            }
            ... on DepositPaymentReportOutput {
              ownerAccountName
              reference
            }
          }
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        pageSize
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

